import classnames from 'classnames';
import { ErrorBoundary } from 'components/Errors/ErrorBoundary';
import LoadingScreen from 'components/LoadingScreen';
import history from 'history.js';
import { useAtom } from 'jotai';
import { ensureAccessTokenVerified } from 'lib/auth';
import { isAdminUserLoggedIn } from 'lib/helper';
import React, { Suspense, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { currentDashboardAtom } from 'views/state';

import CADashboard from './CADashboard';
import EPDashboard from './EPDashboard';
import PCDashboard from './PCDashboard';
import SASTDashboard2 from './SASTDashboard2';
import { DashboardType } from './types';
import WADashboard from './WADashboard';

const Dashboard2 = (_props) => {
  const [currentDashboard, setCurrentDashboard] = useAtom(currentDashboardAtom);
  const url = window.location.href;

  useEffect(
    () => {
      ensureAccessTokenVerified();
    },
    [
      /* on mount only once */
    ],
  );

  useEffect(() => {
    var regex = /dashboard#(.*)/;
    var match = url.match(regex);

    // Check if the match exists
    if (match && match.length >= 2) {
      let tabId = match[1];
      switch (tabId) {
        case 'cloud_agent':
          setCurrentDashboard(DashboardType.CA);
          break;
        case 'endpoint':
          setCurrentDashboard(DashboardType.EP);
          break;
        case 'web_app':
          setCurrentDashboard(DashboardType.WAS);
          break;
        case 'sast2':
          setCurrentDashboard(DashboardType.SAST2);
          break;
        case 'pc':
          setCurrentDashboard(DashboardType.PC);
          // avoid scrolling down to the bottom of the page
          history.push('/dashboard');
          break;
        default:
          break;
      }
    }
  }, [url]);

  const TabLink = ({ title, tabId }) => {
    return (
      <NavItem>
        <NavLink
          className={classnames({ active: currentDashboard === tabId })}
          onClick={() => {
            setCurrentDashboard(tabId);
            // reset the url hash
            window.location.hash = '';
          }}
        >
          <h6 className="mt-1">{title}</h6>
        </NavLink>
      </NavItem>
    );
  };

  const _isAdminUser = isAdminUserLoggedIn();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <div className="content">
        <ErrorBoundary>
          <div className="d-flex">
            <Nav tabs>
              <TabLink title="Cloud Agents" tabId={DashboardType.CA} />
              <TabLink title="Endpoints" tabId={DashboardType.EP} />
              <TabLink title="Web Apps" tabId={DashboardType.WAS} />
              <TabLink title="SAST" tabId={DashboardType.SAST2} />
              {_isAdminUser && (
                <TabLink title="Policy Compliance" tabId={DashboardType.PC} />
              )}
            </Nav>
          </div>
          <TabContent activeTab={currentDashboard}>
            <TabPane tabId={DashboardType.CA}>
              {currentDashboard === DashboardType.CA && (
                <Suspense fallback={<LoadingScreen />}>
                  <CADashboard />
                </Suspense>
              )}
            </TabPane>
            <TabPane tabId={DashboardType.EP}>
              {currentDashboard === DashboardType.EP && (
                <Suspense fallback={<LoadingScreen />}>
                  <EPDashboard />
                </Suspense>
              )}
            </TabPane>
            <TabPane tabId={DashboardType.WAS} className="h-100">
              {currentDashboard === DashboardType.WAS && (
                <Suspense fallback={<LoadingScreen />}>
                  <WADashboard />
                </Suspense>
              )}
            </TabPane>
            <TabPane tabId={DashboardType.SAST2}>
              {currentDashboard === DashboardType.SAST2 && (
                <Suspense fallback={<LoadingScreen />}>
                  <SASTDashboard2 />
                </Suspense>
              )}
            </TabPane>
            {_isAdminUser && (
              <TabPane tabId={DashboardType.PC}>
                {currentDashboard === DashboardType.PC && (
                  <Suspense fallback={<LoadingScreen />}>
                    <PCDashboard />
                  </Suspense>
                )}
              </TabPane>
            )}
          </TabContent>
        </ErrorBoundary>
      </div>
      <ToastContainer />
    </Suspense>
  );
};

export default Dashboard2;
